import React from 'react';
import { oneOfType, array, object } from 'prop-types';
import { map, get, toString, includes } from 'lodash';
import { CounterButton, Text, FlexContainer, Row } from '../../common';

const HorizontalResume = ({ data }) => {
    const items = [
        { label: 'Pendientes', key: 'pendientePicking' },
        { label: 'En Picking', key: 'inPicking' },
        { label: 'Por Auditar', key: 'pendienteAuditoria' },
        { label: 'Por Facturar', key: 'pendienteFacturacion' },
        { label: 'Error facturar', key: 'errorFacturar' },
        { label: 'Facturado', key: 'facturado' },
        { label: 'Anulado', key: 'anulado' },
        { label: 'Total', key: 'total' }
    ];
    return (
        <FlexContainer>
            { map(items, ({ label, key }, index) => {
                const strong = includes(['total'], key);
                return (
                    <Row noWrap align='center'>
                        <Text
                            text={label}
                            nowrap
                            paddingRight={10}
                            paddingLeft={index === 0 ? 0 : 10}
                            strong={strong}
                        />
                        <CounterButton noHover>
                            <Text text={toString(get(data, key, 0))} strong={strong} />
                        </CounterButton>
                    </Row>
                );
            }) }
        </FlexContainer>
    );
};

HorizontalResume.propTypes = {
    data: oneOfType([array, object])
};

HorizontalResume.defaultProps = {
    data: {}
};

export default HorizontalResume;
